import { useSelector } from "react-redux";

// 用户权限钩子
export const useAccess = function (roles) {
  const userRoles = useSelector((state) => state.user.roles);
  const hasAccess = roles.some((role) => userRoles.includes(role));
  return { hasAccess };
};
